import { Injectable } from '@angular/core';

export type StorageKey = 'user' | 'permissionChecked';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  NUMBER_TYPE = '__n__';
  storageSupported = window && window.localStorage;
  storage = window.localStorage || window.sessionStorage;

  set<T = unknown>(key: StorageKey, value: T): void {
    if (!this.storageSupported || value === undefined) return;
    let itemValue: string;
    if (typeof value === 'number') {
      itemValue = `${this.NUMBER_TYPE}${value}`;
    } else if (typeof value === 'object' && value !== null) {
      itemValue = JSON.stringify(value);
    } else {
      itemValue = String(value);
    }
    this.storage.setItem(key, itemValue);
  }

  get(key: StorageKey): string {
    if (!this.storageSupported) {
      return '';
    }
    return this.storage.getItem(key) || '';
  }

  remove(key: StorageKey) {
    if (this.storageSupported) {
      this.storage.removeItem(key);
    }
  }

  clear() {
    if (this.storageSupported) {
      this.storage.clear();
    }
  }
}
